var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._b(
      {
        staticClass: "my-select",
        style: _vm._style,
        attrs: {
          clearable: _vm.clearable,
          disabled: _vm.disabled,
          multiple: _vm.multiple,
          filterable: _vm.filterable,
          "collapse-tags": _vm.collapseTags,
        },
        on: { change: _vm.change, blur: _vm.blur },
        model: {
          value: _vm._value,
          callback: function ($$v) {
            _vm._value = $$v
          },
          expression: "_value",
        },
      },
      "el-select",
      _vm.$attrs,
      false
    ),
    [
      _vm.noLabel
        ? [
            _vm.allOption
              ? _c("el-option", {
                  attrs: { label: _vm.$t("components.global.all"), value: "" },
                })
              : _vm._e(),
            _vm._l(_vm.options, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item, value: item },
              })
            }),
          ]
        : [
            _vm.allOption
              ? _c("el-option", {
                  attrs: { label: _vm.$t("components.global.all"), value: "" },
                })
              : _vm._e(),
            _vm._l(_vm.options, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: {
                  label:
                    typeof item === "object" ? item[_vm.keyValue.label] : item,
                  value:
                    typeof item === "object" ? item[_vm.keyValue.value] : item,
                },
              })
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }